// handleSendOtp.js
import { sendInternationalOtp } from "../api";

export function handleSendOtp(contact) {
  return sendInternationalOtp(contact)
    .then((resp) => {
      return resp; // Normal success
    })
    .catch((err) => {
      console.error("International OTP error:", err);

      // If backend returns 429 (Too Many Requests)
      if (err?.status === 429) {
        const msg = err.data?.message || "";

        // Extract wait seconds from message: “Please wait XX seconds”
        const match = msg.match(/(\d+)\s*seconds?/i);

        const waitSeconds = match ? match[1] : null;

        if (waitSeconds) {
          alert(`OTP already sent. Try again after ${waitSeconds} seconds.`);
        } else {
          alert(`OTP already sent. Try again later.`);
        }

        return { success: false, retryAfter: waitSeconds };
      }

      // Other unknown error
      alert("Unable to send OTP. Please try again.");
      throw err;
    });
}